import type { Package } from '@renderer/types/configState'

export interface BkPrintOption {
  quantity: number
  price: number
}

/**
 * The print counts a guest can choose, from the project's packages — read as
 * stock checkout reads them: a package's price is the price of THAT MANY
 * prints, not a unit price, so "2 for RM25" is simply the quantity-2 package.
 *
 * Inactive and non-print packages are skipped, the first package for a count
 * wins, and a project whose only package is not typed "print" still sells one.
 */
export function printOptionsOf(packages: Package[]): BkPrintOption[] {
  const byQuantity = new Map<number, BkPrintOption>()
  for (const p of packages) {
    if (p?.type !== 'print' || p.isActive === false) continue
    const quantity = Number(p.quantity) || 1
    if (!byQuantity.has(quantity))
      byQuantity.set(quantity, { quantity, price: Number(p.price) || 0 })
  }
  if (!byQuantity.size && packages[0]) {
    byQuantity.set(1, { quantity: 1, price: Number(packages[0].price) || 0 })
  }
  return [...byQuantity.values()].sort((a, b) => a.quantity - b.quantity)
}
